import BaseService from "@/services/BaseService";
import {http} from "./config"

class PosVendaAtividadeService extends BaseService {
  constructor() {
    super("/v1/crm/pos-venda-atividades");
  }

  listar(data){
    return http.get(`/v1/crm/pos-venda-atividades?pos_venda_id=${data.id}`)
  }
}

export default new PosVendaAtividadeService();
